<template>
  <div class="content">
    <div class="answer_box">
      <div class="answer_card">
        <div class="card_top">
          <p class="title">答题卡</p>
          <div class="judg_box">
            <div>
              <img src="../../../assets/icon/paper_right01.png" alt="" />
              <span>{{ correctNumber }}</span>
            </div>
            <div>
              <img src="../../../assets/icon/paper_error01.png" alt="" />
              <span>{{ errorNumber }}</span>
            </div>
          </div>
        </div>

        <div class="topic_list">
          <div
            v-for="(items, indexs) in paperList"
            :key="indexs"
            style="cursor: pointer"
            :class="
              items.userAnswer && items.isSubmit && items.isCorrect
                ? 'correct_box'
                : items.userAnswer && items.isSubmit && !items.isCorrect
                ? 'error_box'
                : ''
            "
            @click="current = indexs"
          >
            {{ indexs + 1 }}
          </div>
        </div>

        <div class="btn_box">
          <el-button class="btn1" @click="exeClose()">暂时退出</el-button>
          <el-button type="primary" class="btn2" @click="exeSubmit()"
            >结束练习</el-button
          >
        </div>
      </div>
      <div class="answer_info">
        <div class="watermark-box">
          <div class="watermark-item">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
          <div class="watermark-item right">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
          <div class="watermark-item">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
          <div class="watermark-item right">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
          <div class="watermark-item">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
          <div class="watermark-item right">
            {{
              getTreeType(this.$route.query.teachProperty) +
              this.$store.state.user.name
            }}
          </div>
        </div>
        <div>
          <multiple-choice
            class="multiple_choice"
            :paper-data="paperList[index]"
            :current="current"
            :total="total"
            :index="index"
            :paperName="paperName"
            @selected="selected"
            @prev="prev"
            @next="next"
            v-for="(item, index) in paperList"
            :key="index"
          ></multiple-choice>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { TeachingClassList } from "@/api/bookstore/bookstore";
import { mapGetters } from "vuex";
import {
  continueAnswerQuestions,
  CreateAnswerPaperRecord,
  CreateAnswerRecord,
  submitAnswerPaperRecord,
  GetTestPaperDetail,
} from "@/api/answer/answer.js";
import { paperGetToken } from "@/api/index/index";
import multipleChoice from "./components/multipleChoice.vue";
export default {
  components: {
    multipleChoice,
  },
  data() {
    return {
      testPaperId: "",
      paperPlatform: "out",
      aprId: "",
      paperList: [],
      testPaperModuleList: [],
      total: 0,
      current: 0,
      errorNumber: 0, //答错数量
      correctNumber: 0, //答对数量
      atNumber: 0, //第几题
      answerResults: "", //选择的答案
      questionId: "", //当前所作答的试题Id
      testPaperModuleCurrent: 0,
      testPaperModuleTotal: 0,
      paperName: "",
      goodsId: "",
      teachingAttribute: "",
    };
  },
  mounted() {
    this.testPaperId = this.$route.query.id;
    this.goodsId = this.$route.query.goodsId;
    this.getAnswerQuestions();
    // this.getTestPaperDetail()
    //查询某一项教学属性下的分类
    let catalogType = "train_property";
    TeachingClassList(catalogType).then((res) => {
      if (res.code == 200) {
        this.teachingAttribute = res.data;
      }
    });
  },
  computed: {
    ...mapGetters(["name", "userId"]),
  },
  methods: {
    getTreeType(id) {
      for (let i = 0; i < this.teachingAttribute.length; i++) {
        if (this.teachingAttribute[i].id == id) {
          return this.teachingAttribute[i].label;
        }
      }
    },
    getAnswerQuestions() {
      paperGetToken().then((res) => {
        let data = {
          userId: this.userId,
          paperId: this.testPaperId,
          token: res.data,
        };
        continueAnswerQuestions(data).then((res) => {
          // 判断用户是否存在未答完的练习，如果存在继续作答，不存在则生产新的练习， code===205表示不存在
          if (res.code === 200) {
            this.paperName = res.data.tTestPaperDetailInfoVo.paperName;
            this.aprId =
              res.data.answerQuestionRecordList.length > 0
                ? res.data.answerQuestionRecordList[0].aprId
                : "";
            this.testPaperModuleList =
              res.data.tTestPaperDetailInfoVo.testPaperModuleList;
            console.log(this.testPaperModuleList);
            this.testPaperModuleTotal = this.testPaperModuleList.length;
            if (this.testPaperModuleList) {
              this.testPaperModuleList.map((item) => {
                this.paperList = this.paperList.concat(item.questionList);
              });
            }
            this.paperList.map((item, index) => {
              // questionType:1单选、questionType:2多选、questionType:3判断类型试题
              this.$set(item, "isCorrect", false); //是否提交答案
              if (item.questionType == 1 || item.questionType == 2) {
                let list = [];
                JSON.parse(item.standardAnswer).map((items) => {
                  list.push(items.title);
                });
                this.$set(item, "correctAnswer", list.toString()); //正确答案
              } else if (item.questionType == 3) {
                this.$set(
                  item,
                  "correctAnswer",
                  JSON.parse(item.standardAnswer)[0]
                ); //正确答案
              }

              if (
                res.data.answerQuestionRecordList.length > 0 &&
                res.data.answerQuestionRecordList[index].answerResults
              ) {
                //如果已提交过答案
                this.$set(
                  item,
                  "userAnswer",
                  res.data.answerQuestionRecordList[index].answerResults
                ); //用户答案
                this.$set(item, "isSubmit", true); //是否提交答案
                if (
                  res.data.answerQuestionRecordList[index].answerSituation ==
                  "1"
                ) {
                  this.paperList[index].isCorrect = true;
                  this.correctNumber++;
                } else {
                  this.paperList[index].isCorrect = false;
                  this.errorNumber++;
                }
              } else {
                this.$set(item, "userAnswer", ""); //用户答案
                this.$set(item, "isSubmit", false); //是否提交答案
              }
            });
            console.log(this.paperList);
            this.total = this.paperList.length;
          } else if (res.code == 205) {
            this.createAnswerPaperRecord();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    createAnswerPaperRecord() {
      paperGetToken().then((res) => {
        let data = {
          userId: this.userId,
          paperId: this.testPaperId,
          userName: this.name,
          testDate: this.GET_CURRENT_TIME(),
          token: res.data,
        };
        CreateAnswerPaperRecord(data).then((res) => {
          this.aprId = res.msg;
          this.getTestPaperDetail();
        });
      });
    },
    // 获取考试试卷详情
    getTestPaperDetail() {
      paperGetToken().then((res) => {
        let data = {
          paperId: this.testPaperId,
          ansRecordId: this.aprId,
          token: res.data,
        };
        GetTestPaperDetail(data).then((res) => {
          this.paperName = res.data.paperName;
          this.testPaperModuleList = res.data.testPaperModuleList;
          this.paperList = res.data.testPaperModuleList[0].questionList || [];
          this.paperList.map((item) => {
            // if (item.questionType == 1 || item.questionType == 2) {
            // 	let list = []
            // 	JSON.parse(item.standardAnswer).map((items) => {
            // 		list.push(items.title)
            // 	})
            // 	this.$set(item,'correctAnswer',list.toString()) //正确答案
            // } else if (item.questionType == 3) {
            // 	this.$set(item,'correctAnswer',JSON.parse(item.standardAnswer)[0]) //正确答案
            // }
            this.$set(item, "correctAnswer", ""); //正确答案
            this.$set(item, "userAnswer", ""); //用户答案
            this.$set(item, "isSubmit", false); //是否提交答案
            this.$set(item, "isCorrect", false); //回答是否正确
          });

          this.total = this.paperList.length;
        });
      });
    },
    GET_CURRENT_TIME() {
      let date = new Date();
      let y = date.getFullYear(); //年
      let m = date.getMonth() + 1; //月份
      let d = date.getDate(); //日
      let h = date.getHours(); //小时
      let f = date.getMinutes(); //分
      let s = date.getSeconds(); //秒
      let data =
        y +
        "-" +
        (m > 9 ? m : "0" + m) +
        "-" +
        (d > 9 ? d : "0" + d) +
        " " +
        (h > 9 ? h : "0" + h) +
        ":" +
        (f > 9 ? f : "0" + f) +
        ":" +
        (s > 9 ? s : "0" + s);
      return data;
    },
    // 单选、多选、判断选择答案回调
    selected(e) {
      this.paperList[this.current].userAnswer = e;
      this.answerResults = e;
    },
    // 上一题
    prev() {
      if (this.current > 0) {
        this.current--;
      }
      // else {
      //   if (this.testPaperModuleCurrent > 0) {
      //     this.testPaperModuleCurrent--;
      //     this.getAnswerQuestions();
      //     this.current = this.total + 1;
      //   }
      // }
    },
    // 下一题
    next() {
      if (
        this.paperList[this.current].userAnswer &&
        !this.paperList[this.current].isSubmit
      ) {
        this.createAnswerRecord();
      } else if (this.current != this.total - 1) {
        if (this.current < this.total - 1) {
          this.current++;
        }
      } else if (this.current == this.total - 1) {
        this.exeSubmit();
      }
    },
    judgmentAnswer(str1, str2) {
      let arr1 = [];
      let arr2 = [];
      // 把两个字符串分别用循环转换为数组
      for (let i = 0; i < str1.length; i++) {
        arr1.push(str1.charAt(i));
      }
      for (let i = 0; i < str2.length; i++) {
        arr2.push(str2.charAt(i));
      }
      // 将数组内元素排序，再转化为字符串比较
      if (arr1.sort().toString() == arr2.sort().toString()) {
        return true;
      } else {
        return false;
      }
    },
    judgmentAnswer(str1, str2) {
      let arr1 = [];
      let arr2 = [];
      // 把两个字符串分别用循环转换为数组
      for (let i = 0; i < str1.length; i++) {
        arr1.push(str1.charAt(i));
      }
      for (let i = 0; i < str2.length; i++) {
        arr2.push(str2.charAt(i));
      }
      // 将数组内元素排序，再转化为字符串比较
      if (arr1.sort().toString() == arr2.sort().toString()) {
        return true;
      } else {
        return false;
      }
    },
    judgmentAnswer(str1, str2) {
      let arr1 = [];
      let arr2 = [];
      // 把两个字符串分别用循环转换为数组
      for (let i = 0; i < str1.length; i++) {
        arr1.push(str1.charAt(i));
      }
      for (let i = 0; i < str2.length; i++) {
        arr2.push(str2.charAt(i));
      }
      // 将数组内元素排序，再转化为字符串比较
      if (arr1.sort().toString() == arr2.sort().toString()) {
        return true;
      } else {
        return false;
      }
    },
    toCapital(index) {
      let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return arr[index];
    },
    createAnswerRecord() {
      paperGetToken().then((res) => {
        CreateAnswerRecord({
          questionId: this.paperList[this.current].id,
          answerPlatform: this.paperPlatform,
          userId: this.userId,
          userName: this.name,
          paperId: this.testPaperId,
          answerDate: this.GET_CURRENT_TIME(),
          answerResults: this.answerResults,
          aprId: this.aprId,
          token: res.data,
        }).then((res) => {
          if (res.data.questionType == 1 || res.data.questionType == 2) {
            let list = [];
            JSON.parse(res.data.standardAnswer).map((item) => {
              list.push(item.title);
            });
            this.paperList[this.current].correctAnswer = list.toString();
          } else if (res.data.questionType == 3) {
            this.paperList[this.current].correctAnswer = JSON.parse(
              res.data.standardAnswer
            )[0];
          }
          this.paperList[this.current].analysis = res.data.analysis;

          this.paperList[this.current].isSubmit = true; //将答案和解析添加到数据中
          if (
            this.judgmentAnswer(
              this.paperList[this.current].userAnswer,
              this.paperList[this.current].correctAnswer
            )
          ) {
            this.paperList[this.current].isCorrect = true;
            this.correctNumber++;
          } else {
            this.paperList[this.current].isCorrect = false;
            this.errorNumber++;
          }
        });
      });
    },
    // 暂时退出
    exeClose() {
      this.$confirm("是否要暂时退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          path: "/willingLearn/courseQuestions",
          query: {
            goodsId: this.goodsId,
          },
        });
      });
    },
    // 结束练习
    exeSubmit() {
      this.$confirm("是否要结束练习?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        paperGetToken().then((res) => {
          submitAnswerPaperRecord({
            paperId: this.testPaperId,
            params1: this.goodsId,
            answerPlatform: this.paperPlatform,
            userId: this.userId,
            id: this.aprId,
            userName: this.name,
            testDate: this.GET_CURRENT_TIME(),
            token: res.data,
          }).then((res) => {
            this.$message({
              type: "success",
              message: "提交成功!",
              duration: 1500,
            });
            setTimeout(() => {
              this.$router.push({
                path: "/willingLearn/courseQuestions",
                query: {
                  goodsId: this.goodsId,
                },
              });
            }, 1500);
          });
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  .answer_box {
    display: flex;
    align-items: flex-start;
    margin: 37px auto;
    .answer_card {
      width: 304px;
      background-color: #fff;
      margin-right: 16px;
      padding-bottom: 32px;
      .card_top {
        padding: 18px 20px 18px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          position: relative;
        }
        .title::before {
          content: "";
          width: 4px;
          height: 22px;
          position: absolute;
          left: -10px;
          background-color: #2e9adb;
        }
        .judg_box {
          width: 90px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          div {
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
            }
            img {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
      }
      .card_title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        padding: 0 20px 20px 30px;
      }
      .topic_list {
        display: grid;
        width: 288px;
        border-bottom: 1px solid #f2f2f2;
        padding: 0 22px 20px 22px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        grid-row-gap: 9px;
        grid-column-gap: 15px;
        justify-content: start;
        grid-template-columns: repeat(auto-fit, 21px);

        div {
          width: 21px;
          height: 21px;
          background: #ffffff;
          border: 1px solid #999999;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .correct_box {
          background: #70b603;
          color: #fff;
        }
        .error_box {
          background: #d9001b;
          color: #fff;
        }
      }
      .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        button {
          width: 121px;
          height: 41px;
          border-radius: 6px;
        }
        .btn1 {
          border: 1px solid #2e9adb;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #2e9adb;
        }
        .btn2 {
          background: #2e9adb;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .answer_info {
      width: 1080px;
      min-height: 720px;
      padding-bottom: 20px;
      background-color: #fff;
      position: relative;
      .watermark-box {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        pointer-events: none;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        .watermark-item {
          color: #999;
          pointer-events: none;
          display: inline-block;
          width: 848px;
          padding-bottom: 60px;
          font-size: 30px;
          transform: rotate3d(1, 1, 3, -45deg);
          // line-height: 200rpx;
          // transform: rotateZ(-45deg);
          opacity: 0.1;
        }

        .right {
          text-align: right;
        }
      }
      .multiple_choice {
        z-index: 99;
      }
    }
  }
}
</style>
